// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"786a1b48","279":"4a14696e","659":"362bb4ee","763":"a8509209"}[chunkId] + ".css";
};